var map = {
	"./analitics.svg": "9649",
	"./arrow-down.svg": "b4c8",
	"./arrow-left.svg": "f6db",
	"./arrow-right.svg": "8281",
	"./courses.svg": "9ea3",
	"./default-avatar.svg": "7fab",
	"./doc.svg": "f4e6",
	"./edit.svg": "2dd2",
	"./events.svg": "6e35",
	"./eye.svg": "083f",
	"./facebook.svg": "7e4b",
	"./finger-up.svg": "b8f0",
	"./google.svg": "4460",
	"./info.svg": "69d9",
	"./instagram.svg": "48d6",
	"./like.svg": "8909",
	"./lock.svg": "3b18",
	"./logo-full.svg": "2d00",
	"./logo-mobile.svg": "9dbc",
	"./menu.svg": "1f69",
	"./music.svg": "65ea",
	"./pencil.svg": "be21",
	"./photo.svg": "d740",
	"./play-blue.svg": "653d",
	"./play.svg": "af53",
	"./plus.svg": "4eb1",
	"./questions.svg": "dbd7",
	"./search.svg": "0a17",
	"./sent.svg": "93b4",
	"./settings.svg": "bc64",
	"./sign-in.svg": "c626",
	"./task.svg": "1e19",
	"./tasks.svg": "a697",
	"./tasks/calendar.svg": "afb0",
	"./tasks/content.svg": "e541",
	"./tasks/letters-orange.svg": "6f81",
	"./tasks/letters.svg": "3567",
	"./tasks/material.svg": "ba7c",
	"./tasks/message-orange.svg": "5464",
	"./tasks/sounds-orange.svg": "6b1e",
	"./tasks/test.svg": "fb8f",
	"./teacher-notification.svg": "bf72",
	"./timer.svg": "fd1c",
	"./times.svg": "3cbc",
	"./training.svg": "c852",
	"./twitter.svg": "5a0b",
	"./user-plus.svg": "99da",
	"./users.svg": "2728",
	"./video.svg": "2b54",
	"./vk.svg": "b6d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";